import * as React from "react";
import {BotPage, BotPageProps} from "./BotPage";
import {BotAppSettingsState, BotAppSettings } from "./BotAppSettings";

export interface AzurePortalPageProps extends React.Props<AzurePortalPage> {
    botPageProps: BotPageProps;
    onSetBotAppSettings(settings: BotAppSettings);
    onSetComponent(x: AzurePortalPage): void;
}

export interface AzurePortalPageState extends BotAppSettingsState  {
    botId: string;
    scmType: string;
}


export class AzurePortalPage extends React.Component<AzurePortalPageProps, AzurePortalPageState> {
    constructor(props) {
        super(props);
        this.state = {
            botId: null,
            scmType: 'None',
            bot: null
        };
    }

    public componentWillUnmount() {
        this.props.onSetComponent(null);
    }

    public componentDidMount() {
        this.props.onSetComponent(this);
    }

    public render(): JSX.Element {
        if (this.props.botPageProps && this.state.botId) {
            return (<BotPage onSetBotAppSettings={this.props.onSetBotAppSettings}
                {...this.props.botPageProps}
                scmType={() => { return this.state.scmType; }}
            />);
        }
        return null;
    }
}




// WEBPACK FOOTER //
// ./Client/v4/Views/AzurePortalPage.tsx